import React from 'react';
import { modules } from '../data/modules';
export function Modules() {
  return <section className="bg-white py-6 sm:py-9" data-id="element-102" data-mp="1r63rh4h50cko">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-103" data-mp="1r4so35rlt6u3">
        <h2 className="text-center text-[25px] leading-none text-navy sm:text-[40px]" data-id="element-104" data-mp="1vwk6uu4iq89o">
          What's <span className="text-diag" data-id="element-105" data-mp="20wonql9c950f">included</span>
        </h2>

        <div className="mt-4 grid gap-2.5 sm:gap-3 lg:grid-cols-2" data-id="element-106" data-mp="20y9fy486kbv4">
          {modules.map(module => <article key={module.label} className="flex flex-col rounded-md border border-line bg-white p-3.5 sm:p-4" style={{
          borderLeft: `5px solid ${module.color}`
        }} data-id="element-107" data-mp="1488y6p68avnb">
              <p className="font-display text-[12px] font-semibold uppercase tracking-[0.14em]" style={{
            color: module.color
          }} data-id="element-108" data-mp="1i66zasvjgvkv">
                {module.label}
              </p>
              <h3 className="mt-1 text-[16.5px] leading-[1.1] text-navy sm:text-[20px]" data-id="element-109" data-mp="2tjj5vbionsaq">
                {module.title}
              </h3>
              <p className="mt-1.5 text-[13.5px] font-medium leading-snug text-steel sm:text-[15px]" data-id="element-110" data-mp="1sqi3f38jzuc">
                {module.body}
              </p>
              <p className="mt-auto pt-2.5 font-display text-[13px] font-semibold uppercase tracking-wide text-diag" data-id="element-111" data-mp="3oyptfk110a3c">
                {module.tagline}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}